/** Narrows the dashboard to one or more departments; an empty selection means "all departments"
 * (contracts/api.md: `?department=` is optional and repeatable). Shared across the Manager's own
 * dashboard and the CO Member's per-company view. */
export function DepartmentFilter({
  options,
  selected,
  onChange,
}: {
  options: string[];
  selected: string[];
  onChange: (departments: string[]) => void;
}) {
  function toggle(department: string) {
    onChange(selected.includes(department) ? selected.filter((d) => d !== department) : [...selected, department]);
  }

  return (
    <div className="mb-4 flex flex-wrap items-center gap-2">
      <span className="text-sm text-body">Department:</span>
      {options.map((department) => (
        <button
          key={department}
          onClick={() => toggle(department)}
          aria-pressed={selected.includes(department)}
          className={`rounded px-3 py-1 text-sm ${
            selected.includes(department) ? "bg-brand text-surface" : "bg-surface-alt text-ink"
          }`}
        >
          {department}
        </button>
      ))}
      {selected.length > 0 && (
        <button onClick={() => onChange([])} className="text-sm text-brand">
          Clear filter
        </button>
      )}
    </div>
  );
}
